export function getMobilePlatform() {
    if (typeof navigator === "undefined") {
        return null;
    }

    const userAgent = navigator.userAgent || "";

    if (/android/i.test(userAgent)) {
        return "android";
    }

    if (
        /iPad|iPhone|iPod/i.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
        return "ios";
    }

    return null;
}

// Phones get one free song per day on the web; after that we point them to the app.
const FREE_PLAY_KEY = "nomad_mobile_free_play";

function today() {
    const now = new Date();
    return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
}

function readFreePlay() {
    try {
        return JSON.parse(window.localStorage.getItem(FREE_PLAY_KEY)) || {};
    } catch (error) {
        return {};
    }
}

// True when this play is today's free song: nothing used yet today, or replaying that same song.
export function canUseFreePlay(id) {
    if (typeof window === "undefined") return false;
    const used = readFreePlay();
    return used.date !== today() || String(used.id) === String(id);
}

export function markFreePlay(id) {
    try {
        window.localStorage.setItem(FREE_PLAY_KEY, JSON.stringify({ date: today(), id }));
    } catch (error) {
        // Storage blocked (private mode): the free song simply isn't remembered.
    }
}
